import { BaseDto } from '@greco/util-dto';
import { UserCommunityAgreement } from '../models';

export class CreateEventCommunityAgreementDto extends BaseDto {
  userCommunityAgreement: UserCommunityAgreement;
  eventId: string;
  signedOn: Date;
}
